// todo: we should move this to using window.__config__ as it will help with making a single artifact for each env

export const API_URL = process.env.REACT_APP_API_URL ?? "";
export const DROPBOX_CLIENT_ID = process.env.REACT_APP_DROPBOX_CLIENT_ID ?? "";
export const DROPBOX_REDIRECT_URI = process.env.REACT_APP_DROPBOX_REDIRECT_URI ?? "";